import React from 'react'

const CustomerHubContext = React.createContext({})

export default CustomerHubContext
